export function formatDuration(
    seconds: number | string,
    returnMilliseconds: boolean = false,
    includeHours: boolean = false
): string {
    if (typeof seconds === "number") {
        const hours = Math.floor(seconds / 3600);
        const minutes = includeHours
            ? Math.floor((seconds % 3600) / 60)
            : Math.floor(seconds / 60); // minuti totali se non uso ore
        const remainingSeconds = Math.floor(seconds % 60);
        const milliseconds = Math.floor((seconds - Math.floor(seconds)) * 1000);

        const formattedHours = String(hours).padStart(2, "0");
        const formattedMinutes = String(minutes).padStart(2, "0");
        const formattedSeconds = String(remainingSeconds).padStart(2, "0");
        const formattedMilliseconds = milliseconds.toString().padStart(3, "0");

        let result = includeHours
            ? `${formattedHours}:${formattedMinutes}:${formattedSeconds}`
            : `${formattedMinutes}:${formattedSeconds}`;

        if (returnMilliseconds) {
            result += `.${formattedMilliseconds}`;
        }

        return result;
    }

    return seconds;
}


export function formatUTCDate(dateString: string, includeSeconds: boolean = true, includeTime: boolean = true): string {
    if (dateString && !dateString.includes('Z')){
        dateString += 'Z';
    }
    const date = new Date(dateString);
    if (isNaN(date.getTime())){
        return '';
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    let ris = `${day}-${month}-${year}`;
    if (includeTime) {
        ris += ` ${hours}:${minutes}`;
    }
    if (includeSeconds) {
        ris += ':'+seconds;
    }
    return ris;
}
